import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
import { Paths } from '../../../helpers/constants';
import { BreadcrumbLink } from '../BreadcrumbLink';

export const HomeLink = () => (
    <BreadcrumbLink icon={<HomeIcon style={{ width: 20, height: 20 }} />} text='Home' to={Paths.home} />
)